import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchRoles } from '../../predict/src/core/api/roles';
import { queryClient } from '../core/queryClient';

type FetchRolesResult = Awaited<ReturnType<typeof fetchRoles>>;
type RolesQueryOptions = Omit<QueryObserverOptions<FetchRolesResult>, 'queryKey' | 'queryFn'>;

export const rolesQueryKey = (workspaceId: string) => ['roles', workspaceId];

export const rolesQuery = (
  workspaceId: string,
  options?: RolesQueryOptions
): QueryObserver<FetchRolesResult> =>
  new QueryObserver<FetchRolesResult>(queryClient, {
    queryKey: rolesQueryKey(workspaceId),
    queryFn: () => fetchRoles(workspaceId),
    ...options
  });

export const clearRolesQueryCache = (workspaceId: string): void => {
  queryClient.invalidateQueries({ queryKey: rolesQueryKey(workspaceId) });
};
